<template>
  <div>
    <v-row>
      <v-col>
        <h1 class="mb-4">View Trust Group</h1>
      </v-col>
    </v-row>
    <div class="text-left">
      <p class="text-overline">Trust Group Info</p>
      <v-row no-gutters>
        <v-col> <b>Is Customer?</b> {{ trustGroup.isCustomer }} </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <b>Trust Group Type: </b>
          {{ trustGroup.trustGroupType }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <b>Users: </b>
          <span v-for="user in trustGroup.userProfileEmails">{{ user }}, </span>
        </v-col>
      </v-row>

      <p class="text-overline mt-2">Company Info:</p>
      <v-row no-gutters>
        <v-col><b>Company name:</b> {{ trustGroup.company.companyName }}</v-col>
        <v-col
          ><b>Organisation Number:</b>
          {{ trustGroup.company.organisationNumber }}</v-col
        >
        <v-col>
          <b>Operating Country:</b>
          {{ trustGroup.company.operatingCountryCode }}
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-2">
      <PSecondaryButton class="mb-6 mt-8 ml-3" @click="exitToTrustGroupSearch"
        >Back</PSecondaryButton
      >
      <v-spacer></v-spacer>
      <PPrimaryButton
        v-if="!editingTrustGroup"
        class="mb-6 mt-8 mr-3"
        @click="editingTrustGroup = true"
        >Update Trust Group</PPrimaryButton
      >
    </v-row>
    <EditTrustGroup
      v-if="editingTrustGroup"
      :trust-group="trustGroup"
      @cancel="editingTrustGroup = false"
      @updated="trustGroup = { ...$event }"
    ></EditTrustGroup>
  </div>
</template>

<script setup lang="ts">
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import EditTrustGroup from "@/views/admin-view/EditTrustGroup.vue";
import { onMounted, ref } from "vue";
import { TrustGroup } from "@/models/trustGroup";

const editingTrustGroup = ref(false);

const props = defineProps<{
  trustGroup: TrustGroup;
}>();

const trustGroup = ref(new TrustGroup());

onMounted(() => {
  trustGroup.value = { ...props.trustGroup };
});

const emit = defineEmits<{
  (e: "exit"): void;
}>();

function exitToTrustGroupSearch() {
  emit("exit");
}
</script>
